import React, { useState } from 'react';
import './Sidebar.scss';
import cart from "../../Assets/card.png";
import overview from "../../Assets/overview.png";
import client from "../../Assets/clirent.png";
import product from "../../Assets/product.png";
import { IoSettingsOutline } from "react-icons/io5";
import pay from "../../Assets/pay.png";
import not from "../../Assets/not.png";
import { Link } from "react-router-dom";
export default function Sidebar() {
  const [open, setOpen] = useState(null);
  const [isOpen, setIsOpen] = useState(true);

  return (
    <div className={`sidebar-container ${isOpen ? 'open' : ''}`}>
      <button className="toggle-button" onClick={() => setIsOpen(!isOpen)}>
        ☰
      </button>

      <ul className="menu">
        <li className="menu-item" onClick={() => setOpen(open === "overview" ? null : "overview")}>
          <div className="icon-wrapper"><img src={overview} alt="" width={20} /></div>
          <span>Overview</span>
          {open === 'overview' && (
            <div className="sub-menu-popover">
              <h3>Overview</h3>
              <ul className="sub-menu-list">
             
<li className="sub-menu-item">
  <Link to="/dashboard">Home</Link>
</li>

         <li className="sub-menu-item">
  <Link to="/dashboard/SiteActivity">Site activity</Link>
</li><li className="sub-menu-item">
  <Link to="/dashboard/WidgetsWeb">Widgets Web</Link>
</li> <li className="sub-menu-item">
  <Link to="/dashboard/WidgetsSales">Widgets Sales</Link>
</li><li className="sub-menu-item">
  <Link to="/dashboard/WidgetsMarketing">Widgets Marketing</Link>
</li>  
              </ul>
           </div>
          )}
        </li>

        <li className="menu-item" onClick={() => setOpen(open === "Orders" ? null : "Orders")}>
          <div className="icon-wrapper"><img src={cart} alt="" width={20} /></div>
          <span>Orders</span>
          {open === 'Orders' && (
            <div className="sub-menu-popover">
              <h3>Orders</h3>
              <ul className="sub-menu-list">
                         <li className="sub-menu-item">
  <Link to="/dashboard/Allorders">All Orders</Link>
</li>     
         <li className="sub-menu-item">
  <Link to="/dashboard/Neworders">New Orders</Link>
</li>
         <li className="sub-menu-item">
  <Link to="/dashboard/Cancelledorders">Canceled</Link>
</li>
        
          
        
              </ul>
           </div>
          )}
        </li>

        <li className="menu-item" onClick={() => setOpen(open === "Clients" ? null : "Clients")}>
          <div className="icon-wrapper"><img src={client} alt="" width={20} /></div>
          <span>Clients</span>
          {open === 'Clients' && (
            <div className="sub-menu-popover">
              <h3>Clients</h3>
              <ul className="sub-menu-list">

                <li className="sub-menu-item">
                  <Link to="/dashboard/Clients">Clients</Link></li>
               
              </ul>
           </div>
          )}
        </li>

        <li className="menu-item" onClick={() => setOpen(open === "Payments" ? null : "Payments")}>
          <div className="icon-wrapper"><img src={pay} alt="" width={20} /></div>
          <span>Payments</span>
          {open === 'Payments' && (
            <div className="sub-menu-popover">
              <h3>Payments</h3>
              <ul className="sub-menu-list">
                   <li className="sub-menu-item">
                  <Link to="/dashboard/Movement">Movement</Link></li>
                
                  <li className="sub-menu-item">
                  <Link to="/dashboard/All-Payments">All Payments</Link></li>
              <li className="sub-menu-item">
                  <Link to="/dashboard/Successed-Payments">Successed Payments</Link></li>  <li className="sub-menu-item">
                  <Link to="/dashboard/Refunded-Payments">Refunded Payments</Link></li>
                   <li className="sub-menu-item">
                  <Link to="/dashboard/Sales-Invoice">Sales Invoice</Link></li>
              </ul>

           </div>
          )}
        </li>

        <li className="menu-item" onClick={() => setOpen(open === "Products" ? null : "Products")}>
          <div className="icon-wrapper"><img src={product} alt="Products" width={20} /></div>
          <span>Products</span>
          {open === "Products" && (
            <div className="sub-menu-popover">
              <h3>Products</h3>
              <ul className="sub-menu-list">
                
   
                <li className="sub-menu-item">Products</li>
                             <li className="sub-menu-item">
  <Link to="/dashboard/sales-movement">Sales movement</Link>
</li>
   <li className="sub-menu-item">
  <Link to="/dashboard/StockMovementEdit">Stock & Edit</Link>
</li>
               

                  <li className="sub-menu-item">
  <Link to="/dashboard/AddNewPage">Add new Page</Link>
</li>
              </ul>
            </div>
          )}
        </li>

  <li className="menu-item" onClick={() => setOpen(open === "Marketing" ? null : "Marketing")}>
          <div className="icon-wrapper"><img src={product} alt="Marketing" width={20} /></div>
          <span>Marketing</span>
          {open === "Marketing" && (
            <div className="sub-menu-popover">
              <h3>Marketing</h3>
              <ul className="sub-menu-list">
                
   
                <li className="sub-menu-item">Marketing</li>
 
                             <li className="sub-menu-item">
  <Link to="/dashboard/MarketingStatistics">Statistics</Link>
</li>
   <li className="sub-menu-item">
  <Link to="/dashboard/Creatlinks">Create Links</Link>
</li>
               

                  <li className="sub-menu-item">
  <Link to="/dashboard/Linksociailmedia">Links Social Media</Link>
</li>
              </ul>
            </div>
          )}
        </li>

        <li className="menu-item  mb-5" onClick={() => setOpen(open === "Notifications" ? null : "Notifications")}>
          <div className="icon-wrapper"><img src={not} alt="" width={20} /></div>
          <span>Notifications</span>
          {open === 'Notifications' && (
            <div className="sub-menu-popover">
              <h3>Notifications</h3>
                 <ul className="sub-menu-list">
                   <li className="sub-menu-item">
                  <Link to="/dashboard/Notifications">Notifications</Link></li>
                
                  <li className="sub-menu-item">
                  <Link to="/dashboard/Send-Notes">Send Notes</Link></li>
              {/* <li className="sub-menu-item">
                  <Link to="/dashboard/Successed-Payments">Successed Payments</Link></li>  <li className="sub-menu-item">
                  <Link to="/dashboard/Refunded-Payments">Refunded Payments</Link></li>
                   <li className="sub-menu-item">
                  <Link to="/dashboard/Sales-Invoice">Sales Invoice</Link></li> */}
              </ul>
           </div>
          )}
        </li>




        <li className="menu-item " onClick={() => setOpen(open === "Settings" ? null : "Settings")}>
          <div className="icon-wrapper"><IoSettingsOutline/></div>
          <span>Settings</span>
          {open === "Settings" && (
            <div className="sub-menu-popover">
              <h3>Settings</h3>
              <ul className="sub-menu-list">
                
   
                             <li className="sub-menu-item">
  <Link to="/dashboard/Profile">Profile</Link>
</li>
   <li className="sub-menu-item">
  <Link to="/dashboard/Settings-Informations">information</Link>
</li>
               

                  <li className="sub-menu-item">
  <Link to="/dashboard/Teampermissions">Change Password</Link>
</li>

  



              </ul>
            </div>
          )}
        </li>


        
        <li className="menu-item " onClick={() => setOpen(open === "Manager" ? null : "Manager")}>
          <div className="icon-wrapper"><img src={product} alt="Manager" width={20} /></div>
          <span>Manager</span>
          {open === "Manager" && (
            <div className="sub-menu-popover">
              <h3>Manager</h3>
              <ul className="sub-menu-list">
                
   
                <li className="sub-menu-item">Manager</li>
   <li className="sub-menu-item">
  <Link to="/dashboard/workteam">Work Team</Link>
</li>
       
   <li className="sub-menu-item">
  <Link to="/dashboard/Creatlinks">Create Links</Link>
</li>
               

                  <li className="sub-menu-item">
  <Link to="/dashboard/Teampermissions">Team Permissions</Link>
</li>

                 <li className="sub-menu-item">
  <Link to="/dashboard/Teampermissions">Jobs</Link>
</li>

 <li className="sub-menu-item">
  <Link to="/dashboard/HelpCenter">Help Center</Link>
</li>
        
               <li className="sub-menu-item">
  <Link to="/dashboard/SupportFaqs">Support/FAQs</Link>
</li>

               <li className="sub-menu-item">
  <Link to="/dashboard/PrivacyPolicy">Privacy Policy</Link>
</li>

    <li className="sub-menu-item">
  <Link to="/dashboard/Request">Request</Link>
</li>




              </ul>
            </div>
          )}
        </li>
      </ul>
    </div>
  );
}
